import {
    AbsoluteModelPath,
    AbsoluteResolvedModelPath,
    convertToRelativeModelPath,
    PathTokens,
    RelativeResolvedModelPath,
} from "../../../Common/ModelPath/ModelPath";
import { BindingPath } from "../Engine/Core/CoreTypes";
import { IterUtils } from "../../../Common/IterableUtils";
import { reject } from "../../../Common/TypingUtils";

export function buildDirtyPathForMultiplicityAndCheckboxPath(
    multiplicityPath: AbsoluteResolvedModelPath,
    checkboxPath: RelativeResolvedModelPath | BindingPath
): AbsoluteResolvedModelPath;
export function buildDirtyPathForMultiplicityAndCheckboxPath(
    multiplicityPath: AbsoluteModelPath,
    checkboxPath: RelativeResolvedModelPath | BindingPath
): AbsoluteModelPath;
export function buildDirtyPathForMultiplicityAndCheckboxPath<TAbsolute extends AbsoluteModelPath>(
    multiplicityPath: TAbsolute,
    checkboxPath: RelativeResolvedModelPath | BindingPath
): AbsoluteModelPath {
    const multiplicityPathWithoutLastStar = multiplicityPath.trimLastStarIfLastToken();
    const parentPath = multiplicityPathWithoutLastStar.trimLastStarIfLastToken().getParentPath();
    const lastTokenFromMultiplicityPath = IterUtils.last(multiplicityPathWithoutLastStar.getPathParts());
    const lastTokenAsSimpleToken = PathTokens.isSimpleToken(lastTokenFromMultiplicityPath)
        ? lastTokenFromMultiplicityPath
        : reject(`Invalid token type: only simple token expected!`);
    return parentPath
        .joinWith(`${lastTokenAsSimpleToken}_dirtyCheckboxes`)
        .joinWith(convertToRelativeModelPath(checkboxPath));
}
